import React from 'react'
import { Route } from 'react-router-dom';
import DreRoutes from './dre/Routes';
import ConferenciasRoutes from './conferencias/Routes';
import Empresas from './empresas/Empresas';
import RICMS from './ricms/RICMS';
import Sped from './sped/Sped.jsx';
import SwitchRouter from 'components/SwitchRouter';

export default function Routes({ match: { path } }) {
    const routes = [
        { path: `${path}/dre`, component: DreRoutes },
        { path: `${path}/conferencias`, component: ConferenciasRoutes },
        { exact: true, path: `${path}/empresas`, component: Empresas },
        { exact: true, path: `${path}/regulamento-icms`, component: RICMS },
        { exact: true, path: `${path}/sped`, component: Sped },
    ]
    return (
        <SwitchRouter>
            {routes.map((props, i) => <Route key={i} {...props} />)}
        </SwitchRouter>
    )
}
